import React from "react";

import { Label } from "@client/shadcn/ui/label";
import { buttonVariants } from "@client/shadcn/ui/button";

interface Props {
    className?: string;
    title: string;
    description: string;
}

export const ErrorPage = (props: Props) => {
    return (
        <div className="flex items-center min-h-screen px-4 py-12 sm:px-6 md:px-8 lg:px-12 xl:px-16">
            <div className="flex flex-col items-center w-full gap-6">
                <Label className="text-4xl font-bold tracking-tighter sm:text-5xl">{props.title}</Label>
                <Label>{props.description}</Label>
                <a
                href="/"
                className={buttonVariants({
                    variant: "outline",
                    size: "lg",
                })}>
                    Return to homepage
                </a>
            </div>
        </div>
    );
};
